import { BaseModel } from "../../Bases/BaseModel";
//import { UsuarioFiltroAcesso } from "./UsuarioFiltroAcesso";

export class Motorista extends BaseModel {
    constructor(
        public nome = '',
        public cpf = '',
        public rg = '',
        // public sobrenome = '',
        // public email = '',
        // public celular = '',
        // public email_ratc = '',
        // public email_nao_conformidade = '',
        // public empresa_id = '',
        // public nome_usuario = '',
        // public link_painel_performance = '',
        // public ip = '',
        //public usuarioFiltroAcesso = new UsuarioFiltroAcesso(),
    ) {
        super();
    }
}

